/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Sort_DefaultInputs */

const vi_customer_sort_default = /** @type {(inputs: Customer_Sort_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới nhất`)
};

/**

* @param {Customer_Sort_DefaultInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_sort_default = /** @type {((inputs?: Customer_Sort_DefaultInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Sort_DefaultInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_sort_default(inputs)
});